(function() {
  document.querySelectorAll('[data-faq-item]').forEach(function(item) {
    item.addEventListener('click', function() {
      var isOpen = item.classList.contains('faq__item--open');
      if (isOpen) {
        item.classList.remove('faq__item--open');
      } else {
        item.classList.add('faq__item--open');
      }
    });
  });
})();
